import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Field from "./field.tsx";
import splitIntoGroups from "../../../utils/array-spliter-group.ts";

interface SignerProps {
  name: string;
  status: "awaiting" | "signed" | "refused";
  masterOpen: boolean;
  fields: { label: string; value: string }[];
}




function Signer({
  name,
  status,
  masterOpen,
  fields,
}: SignerProps): React.JSX.Element {
  const { t } = useTranslation();
  const [showDetails, setShowDetails] = useState(true);

  const localStatusList: Record<string, { label: string; icon: JSX.Element }> = {
    awaiting: {
      label: t("signers.status.awaiting"),
      icon: <TimerOutlinedIcon color="inherit" />,
    },
    signed: {
      label: t("signers.status.signed"),
      icon: <TaskAltIcon color="success" />,
    },
    refused: {
      label: t("signers.status.refused", "Recusado"),
      icon: <HighlightOffIcon color="error" />,
    },
  };

  useEffect(() => {
    setShowDetails(masterOpen);
  }, [masterOpen]);

  const splitFields = splitIntoGroups(fields, 3);
  return (
    <>
      <div>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Typography gutterBottom variant="h6">
            {name}
          </Typography>
          <Stack
            alignItems="center"
            direction="row"
            justifyContent="space-between"
            spacing={1.5}
            sx={{
              color: "text.secondary",
            }}
          >
            <Typography variant="body1">{localStatusList[status].label}</Typography>
            {localStatusList[status].icon}
          </Stack>
        </Stack>
        <Stack alignItems="end">
          <div>
            <Button
              onClick={() => {
                setShowDetails(!showDetails);
              }}
              sx={{ textTransform: "capitalize" }}
            >
              {showDetails ? t("signers.showDetails") : t("signers.hideDetails")}
            </Button>
          </div>
        </Stack>
      </div>
      <Collapse in={!showDetails}>
        <Stack spacing={2}>
          {splitFields.map((items) => (
            <Grid columns={3} container key={`${items[0].label}-field-group`}>
              {items.map(({ label, value }) => (
                <Grid key={label + value} size={1}>
                  <Field label={label} value={value} />
                </Grid>
              ))}
            </Grid>
          ))}
        </Stack>
      </Collapse>
      <Divider />
    </>
  );
}

export default Signer;
